import { BaseExportModal, ExportModalProps } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { CONVENIENCE_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/Convenience/ConvenienceColumnsInfo'
import { useDownload } from 'features/download-widget'
import { getDownloadStatus } from 'services/downloadsApi'
import { startConvenienceChainsExportV2 } from 'services/places'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

export default function ConvenienceExportModal(props: ExportModalProps) {
  const dataTypeName = 'Convenience Stores'

  const convenienceColumnHelper = createExportColumnHelper({
    columns: CONVENIENCE_COLUMNS,
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        convenienceColumnHelper.retrieveColumn('name'),
        convenienceColumnHelper.retrieveColumn('city_summary'),
        convenienceColumnHelper.retrieveColumn('state_summary'),
        convenienceColumnHelper.retrieveColumn('zipcode_summary'),
        convenienceColumnHelper.retrieveColumn('domain'),
        convenienceColumnHelper.retrieveColumn('reviews_avg'),
        convenienceColumnHelper.retrieveColumn('reviews_cnt'),
        convenienceColumnHelper.retrieveColumn('open_hours'),
        convenienceColumnHelper.retrieveColumn('doors_cnt'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: `Exporting ${dataTypeName}...` }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await startConvenienceChainsExportV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'Convenience Opportunities',
    })
  }

  return (
    <BaseExportModal
      title={`Select Columns for ${dataTypeName} Download`}
      subTitle={`Download up to 10,000 ${dataTypeName.toLocaleLowerCase()} at a time, with any of the following columns. Any filters already applied will remain active.`}
      submitText={`Export ${dataTypeName}`}
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
